import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, FreeMode} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const slidersInit = ()=> {
    const branchSwiperInit = (className) => {
        const branchSwiper = new Swiper(className + '.swiper', {
            // configure Swiper to use modules
            modules: [Navigation, Pagination],
            pagination: {
                el: className + ' .swiper-pagination',
                dynamicBullets: true,
            },
            navigation: {
                nextEl: className + ' .swiper-next',
                prevEl: className + ' .swiper-prev',
            },


            spaceBetween: 24,
            slidesPerView: 1,
            allowTouchMove: true,

            // freeMode: true,
            breakpoints: {
                768: {
                    allowTouchMove: false
                },
            },
            // Navigation arrows

        });
    }

    const testimonialsSwiperInit = () => {
        const testimonialsSwiper = new Swiper( '.testimonials__massages-list', {
            // configure Swiper to use modules
            modules: [Navigation, Pagination],
            pagination: {
                el: '.testimonials .swiper-pagination',
                dynamicBullets: true,
            },
            navigation: {
                nextEl: '.testimonials .swiper__nav-left',
                prevEl: '.testimonials .swiper__nav-right',
            },

            spaceBetween: 24,
            slidesPerView: 1,
            allowTouchMove: true,

            // freeMode: true,
            breakpoints: {
                700: {
                    spaceBetween: 8,
                    slidesPerView: 2
                },
                1000:{
                    spaceBetween: 8,
                    slidesPerView: 3
                },
                1300: {
                    spaceBetween: 8,
                    slidesPerView: 4
                }

            },
            // Navigation arrows

        });
    }
    const reasonsSwiperInit = () => {
        const reasonsSwiper = new Swiper( '.choose-reason__list', {
            // configure Swiper to use modules
            modules: [Navigation, Pagination],
            pagination: {
                el: '.choose-reason .swiper-pagination',
                dynamicBullets: true,
            },
            spaceBetween: 24,
            slidesPerView: 1,
            allowTouchMove: true,

            // freeMode: true,
            breakpoints: {
                700: {
                    spaceBetween: 8,
                    slidesPerView: 2
                },
                1000:{
                    spaceBetween: 8,
                    slidesPerView: 3
                },
                1300: {
                    spaceBetween: 8,
                    slidesPerView: 5
                }

            },
            // Navigation arrows

        });
    }

    return {
        branchSwiperInit,
        testimonialsSwiperInit,
        reasonsSwiperInit
    }
}

export default slidersInit;
